import { BaseEntity, Entity as DecribeEntity, RelationList } from '@avangard/utils/entity';

import { StudentProfileGroupType } from '@modules/types/graphql';
import { StudentProfileSectionEntityList } from './student-profile-section.entity-list';

import type { StudentProfileGroup } from '@modules/types/graphql';
import type { StudentProfileSectionEntity } from './student-profile-section.entity';

export type Entity = Partial<StudentProfileGroup> | null;

@DecribeEntity('StudentProfileGroupEntity')
class StudentProfileGroupEntity extends BaseEntity {
    type: StudentProfileGroupType;

    @RelationList(() => StudentProfileSectionEntityList)
    sections: StudentProfileSectionEntity[];

    constructor(entity: Entity) {
        super(entity);

        this.type = entity?.type ?? StudentProfileGroupType.summary;
    }
}

export { StudentProfileGroupEntity };
